import React from 'react'
import { Link } from '@mui/material'
import TriggerRenderer from './TriggerRenderer'

/**
 * CustomMenuLink component that renders a link with a custom trigger that opens in a new tab
 *
 * @param {Object} props - Component props
 * @param {Object} props.menuItem - Configuration for the menu item
 * @param {Object} props.menuItem.trigger - Trigger configuration
 * @param {string} props.menuItem.url - URL to navigate to
 */
const CustomMenuLink = ({ menuItem }) => {
    if (!menuItem || !menuItem.trigger || !menuItem.url) return null

    return (
        <Link
            href={menuItem.url}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <TriggerRenderer trigger={menuItem.trigger} />
        </Link>
    )
}

export default CustomMenuLink
